import { AddBusiness, Business, Mail, Phone, Store } from "@mui/icons-material";
import { Box, FormControl, TextField, Button, InputLabel, Select, MenuItem } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import React, { useState, useMemo } from "react";
import { useAuth } from "../hooks/useAuth";
import { ALL_COUNTRIES } from "../helperFunc/countylist";


export const AddCompnayForm = ({
    setmodel,
    storeType,
    planType,
    franchiseID
}) => {
    const { addcmpny } = useAuth();
    const initialState = {
        franchiseID: franchiseID || '',  // This will be set from the parent component
        storeType,
        planType,
        name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        country: '',
        postCode: '',
    };
    const [formData, setFormData] = useState(initialState);
    const { name, email, phone, address, city, state, country, postCode } = formData;
    
    // --- State for dynamic region filtering ---
    const availableRegions = useMemo(() => {
        return ALL_COUNTRIES.find(c => c.code === country)?.regions || [];
    }, [country]);


    const handleRegionChange = (e, field) => {
        const { value } = e.target;
        
        setFormData(prev => {
            let newState = { ...prev, [field]: value };
            
            // If the country changes, reset the state/province field
            if (field === 'country' && prev.country !== value) {
                newState.state = ''; 
            }
            return newState;
        });
    };

    const submitNewBuisness = async () => {
        // alert('This is for Buisness Info');
        addcmpny(formData);
        setFormData(initialState);
        setmodel(false);
    }

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', p: 2 }}>
            <form onSubmit={submitNewBuisness} style={{ width: '100%' }}>
                <FormControl sx={{ m: 1, width: '95%' }} variant="outlined">
                    <TextField
                        placeholder="Buisness Ltd. , Corp."
                        label="Buisness Name"
                        id="BuisnessName"
                        sx={{ m: 1, width: '100%' }}
                        value={name}
                        InputProps={{ startAdornment: (<InputAdornment position="start"><Store /></InputAdornment>) }}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        required
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '95%' }} variant="outlined">
                    <TextField
                        placeholder="Buisness Email"
                        label="Email"
                        id="bemail"
                        sx={{ m: 1, width: '100%' }}
                        InputProps={{ startAdornment: (<InputAdornment position="start"><Mail /></InputAdornment>) }}
                        required
                        value={email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '95%' }} variant="outlined">
                    <TextField
                        placeholder="Buisness Phone"
                        label="Phone"
                        id="bphone"
                        sx={{ m: 1, width: '100%' }}
                        value={phone}
                        InputProps={{ startAdornment: (<InputAdornment position="start"><Phone /></InputAdornment>) }}
                        required
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '95%' }} variant="outlined">
                    <TextField
                        placeholder="Buisness Address"
                        label="Address"
                        id="address"
                        sx={{ m: 1, width: '100%' }}
                        value={address}
                        InputProps={{ startAdornment: (<InputAdornment position="start"><Business /></InputAdornment>) }}
                        onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                        required
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: { xs: '100%', sm: '45%', md: '30%' } }} variant="outlined">
                    <TextField
                        placeholder="Calgary, Toronto, New York"
                        label="City"
                        id="cty"
                        sx={{ m: 1, width: '100%' }}
                        value={city}
                        onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                        required
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: { xs: '100%', sm: '45%', md: '30%' } }} variant="outlined">
                    <TextField
                        placeholder="Postal Code"
                        label="Postal Code"
                        id="pcode"
                        sx={{ m: 1, width: '100%' }}
                        value={postCode}
                        onChange={(e) => setFormData({ ...formData, postCode: e.target.value })}
                        required
                    />
                </FormControl>
                
                {/* --- Country Selector (UPDATED) --- */}
                <FormControl sx={{ m: 1, width: { xs: '100%', sm: '45%', md: '30%' } }} variant="outlined" required>
                    <InputLabel id="country-label">Country</InputLabel>
                    <Select
                        labelId="country-label"
                        value={country}
                        label="Country"
                        onChange={(e) => handleRegionChange(e, 'country')}
                        id="cntry"
                        sx={{ m: 1, width: '100%' }}
                    >
                        <MenuItem value=""><em>Select Country</em></MenuItem>
                        {ALL_COUNTRIES.map((c) => (
                            <MenuItem key={c.code} value={c.code}>
                                {c.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                
                {/* --- State/Province Selector (UPDATED) --- */}
                <FormControl sx={{ m: 1, width: { xs: '100%', sm: '45%', md: '30%' } }} variant="outlined" required>
                    <InputLabel id="state-label">State / Province</InputLabel>
                    <Select
                        labelId="state-label"
                        value={state}
                        label="State / Province"
                        onChange={(e) => handleRegionChange(e, 'state')}
                        id="pro"
                        sx={{ m: 1, width: '100%' }}
                        disabled={!country || availableRegions.length === 0}
                    >
                        <MenuItem value=""><em>Select Region</em></MenuItem>
                        {availableRegions.map((r) => (
                            <MenuItem key={r.code} value={r.code}>
                                {r.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Box sx={{ display: "flex", pt: 5, pl: 2, justifyContent: 'flex-end', width: '100%' }}>
                    <Button variant="contained" type="submit">ADD &nbsp;&nbsp; <AddBusiness /></Button>
                </Box>
            </form>
        </Box>
    )
};